<template>
    <div class="outerBox">
        <div class="innerBox mt-5">
            <h4 style="text-align: left;">Tambah Merk & Tipe Mobil</h4>
            <hr>

            <div class="form">
                <div class="mt-3">
                    <!-- <div></div> -->
                    <label class="label" >Pilih Brand Mobil<span style="color:red">*</span></label>
                    <Multiselect
                        class="mt-1"
                        :options="options.brand.map(x => x.id)"
                        :custom-label="opt => options.brand.find(x => x.id == opt).name"
                        v-model="form.brand_id"
                        placeholder="Pilih Brand Mobil Disini"
                        :disabled="newBrand"
                    />
                    <div class="row row-space mt-2 label">
						<div class="form-check form-check-inline col-12">
							<input class="form-check-input" style="width:2.5%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="newBrand">
							<label class="form-check-label" for="inlineCheckbox1">Klik Box ini jika Nama Brand Mobil Belum Tersedia.</label>
						</div>
					</div>
                </div>
                <div class="mt-4" v-if="newBrand">
                    <!-- <div></div> -->
                    <label class="label" >Nama Brand Mobil<span style="color:red">*</span></label>
                    <input
                        class="mt-1 form-control"
                        type="text"
                        placeholder="Isi Nama Model Mobil Disini"
                        v-model="form.brand_name"
                    />
                </div>
                <div class="mt-4">
                    <!-- <div></div> -->
                    <label class="label" >Nama Model Mobil<span style="color:red">*</span></label>
                    <input
                        class="mt-1 form-control"
                        type="text"
                        placeholder="Isi Nama Model Mobil Disini"
                        v-model="form.name"
                    />
                </div>
            </div>

            <div class="row mt-5">
                <div class="offset-lg-2 col-lg-4 col-6">
                    <button
                        class="btn btn-outline-danger w-100"
                        @click="exitPage"
                    >
                        Kembali
                    </button>
                </div>
                <div class="col-lg-4 col-6">
                    <button
                        class="btn btn-primary w-100"
                        @click="submitForm"
                    >
                        Tambah
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components : {
        Multiselect
    },
    data () {
        return {
            newBrand : false,
            form : {
                brand_id : null,
                brand_name : null,
                name : null
            },
            options : {
                brand : []
            }
        }
    },
    watch : {
        newBrand : function () {
            if(!this.newBrand) delete this.form.brand_name
            else this.form.brand_name = ''
        }
    },
    mounted () {
        this.fetchData()
    },
    methods : {
        fetchData(){
            var vm = this;

            var url = `/api/v1/masterData/car/brand?pagination=false`;

            this.$http.get(url)
            .then((resp)=>{
                // var data = resp.data.data;
                this.options.brand = resp.data.data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        submitForm () {
            // if(this.validateForm(this.form))
            let error = this.validateForm(this.form)

            if(error.length > 1) {
                this.$store.dispatch('triggerAlert' , [false].concat(error))
                return
            }

            this.$http.post('/api/v1/masterData/car' , this.form)
            .then((resp) => {
                this.$store.dispatch('triggerAlert' , [true , 'Input Data Mobil Telah Berhasil.'])
                this.exitPage()
            })
            .catch((err) => {
                console.log(err.response)
                this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong With Error' , err])
            })
        },
        validateForm (form) {
            let error = []

            if(form.name == '' || !form.name) {
                error.push('Mohon diisi nama model mobil!');
            }

            if(!form.brand_id) {
                if(this.newBrand) {
                    if(form.brand_name == '' || !form.brand_name) {
                        error.push('Mohon diisi nama brand mobil!');
                    }
                }
                else {
                    error.push('Mohon dipilih brand mobil yang tersedia di system!')
                }   
            }

            return error
        },
        exitPage () {
            this.$router.push({name : 'CSOMasterBrandAndType'})
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: normal;
    }

    .form-control {
        height:43px;
    }
</style>